import {
    buildConfigSlice,
    useConfigSlice,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { selectVenueExecCapsuleState } from 'widgets/venueAnalysis/capsules/venueExecCapsule/store/selectors';

export const buildVenueExecCapsuleConfigSlice = () =>
    buildConfigSlice<VenueAnalysisCapsuleConfigState>(
        WidgetType.VENUE_EXEC_CAPSULE,
        selectVenueExecCapsuleState,
        initialVenueAnalysisCapsuleConfigState
    );

export const useVenueExecCapsuleConfigSlice = () =>
    useConfigSlice(buildVenueExecCapsuleConfigSlice());
